import posthog from 'posthog-js';
// Required when disable_external_dependency_loading: true — pre-registers
// window.__PosthogExtensions__.errorWrappingFunctions so PostHog can hook
// window.onerror and window.onunhandledrejection for exception autocapture.
import 'posthog-js/dist/exception-autocapture';
// import 'posthog-js/dist/recorder';
// import 'posthog-js/dist/surveys';
// import 'posthog-js/dist/tracing-headers';
import 'posthog-js/dist/web-vitals';

import { IS_DEBUG_ENVIRONMENT } from 'config';

let exceptionsReportedPerSession = 0;

const getExceptionReportRate = (): number => {
  // Get small sample from unsupported browsers too
  if (!window?.appCheckedModernBrowser) {
    if (exceptionsReportedPerSession <= 2) {
      return 0.3; // 30%
    }
    // But no more than 2 errors per session
    return 0; // None
  }

  if (IS_DEBUG_ENVIRONMENT) {
    // We want to catch most and record most errors on Staging/Dev
    if (exceptionsReportedPerSession > 10) {
      return 0.1; // 10%
    } else if (exceptionsReportedPerSession > 5) {
      return 0.5; // 50%
    } else {
      return 1; // 100%
    }
  }

  if (exceptionsReportedPerSession === 0) {
    return 0.8; // 80%
  } else if (exceptionsReportedPerSession <= 2) {
    return 0.5; // 50%
  } else if (exceptionsReportedPerSession <= 10) {
    return 0.1; // 10%
  }
  return 0.01; // 1% of others
};

const POSTHOG_KEY = IS_DEBUG_ENVIRONMENT
  ? 'phc_5RyiFca8qUZmkTmmTXam3wcyJjBR32dtcx7wX1U5Ox1' // Perps (dev) - Katana org
  : 'phc_uPkfg3ZAlaERQ3S4SjqoYo6A8oE5v69oEM1NqjmQJMH'; // Perps - Katana org

const POSTHOG_HOST = 'https://us.i.posthog.com';

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  defaults: '2026-01-30',
  autocapture: false,
  person_profiles: 'identified_only',

  capture_exceptions: true,
  capture_performance: Math.random() < 0.2, // 20% users
  capture_pageleave: true,

  before_send(event) {
    // console.log('EVENT', event);
    if (!event || event.event !== '$exception') {
      return event;
    }
    if (Math.random() >= getExceptionReportRate()) {
      return null;
    }
    exceptionsReportedPerSession += 1;
    return event;
  },

  // Must be disabled with current Content-Security_policy = no script-src
  disable_external_dependency_loading: true, // Stops the attempt to load config.js
  disable_session_recording: true,
});

export const captureExceptionInPosthog = (
  error: Error,
  properties?: Record<string, unknown>
) => {
  posthog.captureException(error, properties ? { properties } : undefined);
};

export const identifyWalletInPosthog = (walletAddress?: string) => {
  const identity = posthog.get_distinct_id();

  const identityLowerCase = identity?.toLowerCase();
  const walletAddressLowerCase = walletAddress?.toLowerCase();

  if (identityLowerCase === walletAddressLowerCase) {
    return;
  }

  // Only change on wallet disconnect or change. Keep (merge session) on unlock.
  // Note: identifier for non-unlocked is looks like "019c9f35-b2de-7ba0-b40b-920da33fc252"
  if (
    identityLowerCase?.startsWith('0x') &&
    identityLowerCase?.toLowerCase() !== walletAddressLowerCase?.toLowerCase()
  ) {
    posthog.reset();
  }

  if (walletAddress) {
    posthog.identify(
      walletAddress
      // { email: 'max@hedgehogmail.com', name: 'Max Hedgehog' } // $set, optional
      // { first_visited_url: '/blog' } // $set_once, optional
    );
  }
};

// setTimeout(() => {
//   throw new Error('Test 3');
// }, 10_000);
